import React from 'react';

import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import Button from '@mui/material/Button';

import useDialogStatus from '../../../hooks/useDialogStatus';
import BulkUpdateDialog from './BulkUpdateDialog';

const BulkUpdatePings = ({ resource = 'cases' }: { resource?: string }) => {
  const { open, openDialog, closeDialog } = useDialogStatus();

  return (
    <>
      <Button
        startIcon={<LibraryAddCheckIcon />}
        onClick={openDialog}
      >
        Bulk Manage
      </Button>
      <BulkUpdateDialog
        open={open}
        closeDialog={closeDialog}
        resource={resource}
      />
    </>
  );
};

export default BulkUpdatePings;
